import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import PlatformRouter from "./components/PlatformRouter";
import Login from "./components/Login";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="/:page" component={PlatformRouter} />
        <Route path="/" component={Login} />
      </Switch>
    </Router>
  );
};

export default App;
